<script>
  import { format } from 'svelte-i18n';
  import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from '@sveltestrap/sveltestrap';

  import Welcome from './welcome.svelte';

  export let assignments = [];
  export let initialBizcard = null;
  export let show = false;

  let sent = false;

  const toggle = () => {
    show = false;
    sent = false;
  };
</script>

{#if show}
  <Modal class="modal-wizard" isOpen size="lg" fullscreen="lg" {toggle} {...$$restProps}>
    <ModalHeader class="text-center" {toggle}>{$format('label.BIZCARD.ASSIGN.SEND_WELCOME_EMAIL')}</ModalHeader>
    <ModalBody>
      <Welcome {assignments} {initialBizcard} bind:sent />
    </ModalBody>
    <ModalFooter>
      <Button on:click={toggle}>
        {$format(sent ? 'label.CLOSE' : 'label.CANCEL')}
      </Button>
    </ModalFooter>
  </Modal>
{/if}
